<style scoped lang="sass">
.vendor-name
  display: inline-block
  font-weight: 600
  margin: 0 0.5rem
.secondary
  // display: inline-block
  color: #888
  font-size: 0.8em
  margin-left: 1.7rem
  .v-divider
    display: inline-block
    width: 1px
    background: #ccc
    height: 1.5em
    margin: 0 0.5rem
    vertical-align: middle
</style>

<template lang='pug'>
.main-container
  
  .view-content
    el-card(v-loading='vendor === null', class='el-card__with-bg')
      div(slot='header')
        i.mat-icon store
        router-link(to='/staff/vendors') Vendors
        |  &gt;
        .vendor-name(v-if='vendor') {{ vendor.name }}
        .secondary(v-if='vendor') Code:
          strong  {{ vendor.code }}
          //- i.mat-icon person
          //- | {{ vendor.people }}
          //- .v-divider
          //- span {{$formatCents(vendor.budget_cents)}}/person
          //- .v-divider
          //- em  \#{{ vendor.id }}
      div(v-if='vendor')
        el-card(v-loading='vendor === null')
          div(slot='header')
            i.mat-icon place
            router-link(to='/staff/vendors') Addresses
            el-button(type="primary", @click="newAddress", style='float: right')
              i.mat-icon add_circle
              | Add address

          vendor-addresses(:vendor='vendor', :addresses='addresses')
  router-view
</template>

<script>

import VendorAddresses from './blocks/VendorAddresses.vue'

function data ( )  {
  return {
    vendor: null,
    addresses: null,
    loading: true,
  }
}

function fetchData ( ) {
  this.$simplecater.get('/vendors/' + this.$route.params.id).then((r)=>{
      this.vendor = r.data.data
    }).catch(()=>{
      this.$message.error("Failed to load the vendor")
    })
    this.$simplecater.get('/vendors/' + this.$route.params.id + '/addresses').then((r)=>{
      this.addresses = r.data.data
    }).catch(()=>{
      this.$message.error("Failed to load the vendor")
    })
}

function created ( ) {
  this.fetchData()
  this.$bus.$on('estimate-accepted', this.fetchData)
  this.$bus.$on('address-saved', this.fetchData)
}

function newAddress ( ) {
  this.$router.push('/staff/vendors/' + this.$route.params.id + '/addresses/new')
}

const methods = {
  fetchData, newAddress
}

const components = { VendorAddresses }

// TODO - Re-fetch on route change/update
export default { data, methods, created, components }
</script>


// WEBPACK FOOTER //
// src/staff/VendorDetail.vue